<script src="../china-pp.js"></script>
<template>
  <div class="map_style">
    <div class="zoomIcon" @click="handleZoom" title="地图放大缩小"></div>
    <div class="sync" @click="handleSync" title="同步数据"></div>
    <div class="hid-alarm-box">
      <el-button-group>
        <el-button
          type="success"
          icon="el-icon-map-location"
          size="mini"
          @click="dialogMapStyleVisible = true"
          >地图配置</el-button
        >
        <el-dropdown
          v-if="alarmlist_in_select.length > 0"
          @command="handle_Select_Command"
        >
          <el-button
            type="success"
            size="mini"
            title="当前报警设备"
            icon="el-icon-message-solid"
            style="color:#ee3608"
            >{{ alarmlist_in_select.length }}</el-button
          >

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="item in alarmlist_in_select"
              :key="item.deviceId"
              :command="item"
            >
              <span>
                {{ item.deviceName }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-button-group>
    </div>

    <div class="amap_box" ref="amapBox">
      <!-- <div class="amap_boxbg"></div> -->
    </div>

    <div class="alarm_box" v-if="alarm_list.length > 0">
      <alarmBox
        @deal="is_receive"
        :alarmContent="alarm_list"
        @showDeatil="alarmDetail"
      ></alarmBox>
    </div>
    <div>
      <audio id="gaode_audiol" preload="auto" style="display: none">
        <source
          src="https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/mp3/baojing.mp3"
          type="audio/mpeg"
        />
      </audio>
    </div>
    <dialogItem
      :show-dialog="showDialog"
      @closeDialog="closeDialog"
      :dialogData="detail"
      @close_alarm="clear_alarm"
    ></dialogItem>
    <dialogdetail
      :isdialogFormVisible="dialogFormVisible"
      :ishiddeCallBack="detailsclose"
      :dialogInfoData="infodata"
      title=""
      width="50%"
      height="50%"
    ></dialogdetail>
    <mapfromedata
      :isdialogFormVisible="dialogMapStyleVisible"
      :ishiddeCallBack="diag_mapstyle_close"
      :submitCallBack="mapsubmitCall"
      :dialogInfoData="infodata"
      width="38%"
      height="50%"
    >
    </mapfromedata>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CircleShow from "./mark_animation";
import createInfo from "./info";
import mapContent from "./info_window.js";
// import points from "../../../../page/main_content/map/china"
import dataUrl from "../../../../libs/js/interfaceAddress.js";
import alarmBox from "../../alarm/alarm_box.vue";
import dialogItem from "../../../../components/dialog/dialogs.vue";
import chinapp from "../../../../page/main_content/map/china-pp";
import localStorage from "../../../../libs/js/localStorage";
import dialogdetail from "../../../../components/dialog/dialog_details.vue";
import mapfromedata from "../../../../components/dialog/dialog_map_style.vue";
import { getUkeyObject } from "../../../login/Ukey/mToken_System";

export default {
  name: "goldenMapnamespace",
  props: {
    searchData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isStatus: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    lineType: {
      type: String,
      default: () => {
        return "";
      }
    }
  },
  data() {
    return {
      amap_map: null,
      mapData: {
        cityname: "中国",
        lnglat: [],
        zoome: '',
        bounds: [],
        Grade: 2
      },
      //弹框详情dialog
      showDialog: false,
      showClickDialog: false,
      dialogFormVisible: false,
      dialogMapStyleVisible: false,
      params: {},
      detail: {
        alarmDetailData: {},
        deviceData: {},
        mesData: {},
        presData: {}
      },
      masklist: [],
      infodata: {
        title: "",
        imei: ""
      },
      //地图数据
      map_data: {}, //获得的地图数据
      alarm_list: [], //报警列表数据
      alarmlist_in_select: [],
      clearMesInterval: null, //警报声的定时器
      onlineNum: 0, //今日实时在线个数
      serach_marker: null,
      search_model: null,
      mapLayer: [],
      // 同步数据记录点击次数，默认为0
      i: 0,
      cluster: null,
      cluster1: null,
      infoWindow: null,
      markers: [],
      markstyle: [
        {
          url: "https://webapi.amap.com/theme/v1.3/m1.png",
          size: new AMap.Size(53, 53)
        },
        {
          url: "https://webapi.amap.com/theme/v1.3/m2.png",
          size: new AMap.Size(54, 54)
        },
        {
          url: "https://webapi.amap.com/theme/v1.3/m3.png",
          size: new AMap.Size(65, 65)
        },
        {
          url: "https://webapi.amap.com/theme/v1.3/m4.png",
          size: new AMap.Size(78, 78)
        },
        {
          url: "https://webapi.amap.com/theme/v1.3/m5.png",
          size: new AMap.Size(78, 78)
        }
      ],
      clusterIndexSet: {
        province: {
          minZoom: 2,
          maxZoom: 6
        },
        city: {
          minZoom: 6,
          maxZoom: 11
        },
        area: {
          minZoom: 11,
          maxZoom: 14
        },
        town: {
          minZoom: 14,
          maxZoom: 16
        },
        community: {
          minZoom: 16,
          maxZoom: 22
        }
      },
      messmark: [],
      district: {},
      add_marker_stus: []
    };
  },
  components: {
    alarmBox,
    dialogItem,
    dialogdetail,
    mapfromedata,
  },
  created() {
    self = this;
  },
  mounted() {
    this.onWindowResize();
    window.addEventListener("resize", this.onWindowResize);
    this.$nextTick(() => {
      this.initBasemap();
    });
    //退出清除音乐
    this.$bus
      .$off("emitter-excu-sign-out-event")
      .$on("emitter-excu-sign-out-event", this.close_audio);
    //点击表头搜索跟前的查看全部点的信息
    this.$bus
      .$off("change-info-event")
      .$on("change-info-event", this.changeInfo);

    //展示部分场站的信息
    this.$bus.$off("part-marker").$on("part-marker", this.changePartMarker);
    this.$bus.$off("returnHome").$on("returnHome", this.returnHome);
    this.$bus.$off("map_init_bus").$on("map_init_bus", this.noticeRefresh);
    this.$bus
      .$off("marker_info_dialogpush")
      .$on("marker_info_dialogpush", this.marker_info_dialogpush);

    var clients = localStorage.getStore("clientData");
    let _that = this;
    window.showDetail = function(i) {
      document.getElementsByClassName("moreData" + i)[0].style.display =
        "block";
      document.getElementsByClassName("more" + i)[0].style.display = "none";
      document.getElementsByClassName("less" + i)[0].style.display = "block";
    };
    window.hideDetail = function(i) {
      document.getElementsByClassName("moreData" + i)[0].style.display = "none";
      document.getElementsByClassName("more" + i)[0].style.display = "block";
      document.getElementsByClassName("less" + i)[0].style.display = "none";
    };
    window.showTag = function(i) {
      var testNode = document.getElementsByClassName("content-window-card")[0];
      testNode.setAttribute("style", "height: auto;");
    };
  },
  computed: {
    ...mapState(["onMessageArrived", "map_config"])
  },
  watch: {
    onMessageArrived: {
      handler(newVal, oldVal) {
        console.log("推送数据来喽-=-=-=-=", newVal);
        this.pullMessage(JSON.parse(newVal));
      },
      deep: true
    },
    searchData: {
      handler(newVal, oldVal) {
        this.handleSearch(newVal);
      }
    }
  },
  methods: {
    ...mapMutations(["set_devToday", "set_onlineNum"]),
    //处理放大缩小 隐藏左右
    handleZoom() {
      this.$emit("handleZoom");
    },
    //同步数据
    handleSync() {
      var count = this.i;
      count++;
      this.i = count;
      if (count <= 1) {
        console.log("同步数据开始-=-=-=-page_init=-=-=-");
        this.page_init();
      } else {
        this.$message({
          showClose: true,
          message: "系统已同步到最新数据",
          type: "warning"
        });
      }
    },
    mapsubmitCall() {
      this.setSrarchMarker_Cluster1_Null();
      this.initCreateMap();
    },
    handle_Select_Command(command) {
      console.log("点击事件-=-=-=-", command);
      this.alarmlist_in_select = this.alarmlist_in_select.filter(function(
        item
      ) {
        if (item.deviceName !== command.deviceName) {
          return item;
        }
      });
      this.alarm_list.push(command);
    },
    //头部搜索
    handleSearch(item) {
      if (JSON.stringify(item[0]) === "[]") {
        return;
      }
      console.log('设备搜索',item)
      var vue = this;
      this.setSrarchMarker_Cluster1_Null();
      this.$http
        .get(dataUrl.interfaceAddress.getDevbounced, {
          params: { deviceId: item[0] }
        })
        .then(res => {
          var body = res.data.body;
          item = [item[0],body.sceneId,body.position]
          this.search_model = {
            sceneId: item[1],
            status: body.status,
            deviceId: item[0],
            lnglat: item[2]
          };
          vue.mapinfowindows_open(body, this.search_model);
          this.amap_map.setZoomAndCenter(20, this.search_model.lnglat);
          //此处为添加单个标记点击事件
          this.serach_marker = new AMap.Marker({
            position: item[2]
          });
          const qiyeHtml = `<img style='width: 20px; height: 20px;' src='${this.getImger(
            this.search_model
          )}'/>`;
          if (this.cluster) {
            this.cluster.setData([]);
          }
          this.serach_marker.setContent(qiyeHtml);
          this.serach_marker.setMap(this.amap_map);
          this.serach_marker.on("click", ev => {
            this.marker_info_dialogpush(this.search_model);
          });
          //此处为添加单个标记点击事件
          this.serach_marker.on("mouseover", ev => {
            vue.mapinfowindows_open(body, this.search_model);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    search_marker_alarm(body) {
      const qiyeHtml = `<img style='width: 20px; height: 20px;' src='${this.getImger(
        this.search_model
      )}'/>`;
      this.serach_marker.setContent(qiyeHtml);
      this.closeInfoWindow();
      this.mapinfowindows_open(body, this.search_model);
    },
    pullMessage(newInfo) {
      //判断推过来数据的类型 去刷相应的图表接口
      if (
        newInfo.action === "offlineNotice" ||
        newInfo.action === "onlineNotice" ||
        newInfo.action === "clearAlarm" ||
        newInfo.action === "emergencyAlarm"
      ) {
        this.$bus.$emit("charts_right_es");
        var status =
          newInfo.action == "onlineNotice" || newInfo.action == "clearAlarm"
            ? 0
            : newInfo.action === "emergencyAlarm"
            ? 2
            : 1;
        this.markers.filter(function(item) {
          if (item.deviceId === newInfo.deviceId) {
            item.status = status;
          }
          return item;
        });
        var zoom = this.amap_map.getZoom(); //获取当前地图级别
        if (zoom >= 16 && this.serach_marker == null) {
          this.cluster1.setData(this.markers);
        }
        this.$http
          .get(dataUrl.interfaceAddress.getDevbounced, {
            params: { deviceId: newInfo.deviceId }
          })
          .then(res => {
            if (res.data.code == 0) {
              if (newInfo.action === "emergencyAlarm") {
                this.devStatusChange(res.data.body, newInfo.deviceId);
                console.log("报警了-=-search_model=-=-=-", this.search_model);
                if (this.search_model) {
                  if (newInfo.deviceId == this.search_model.deviceId) {
                    this.search_model.status = res.data.body.status;
                    this.search_marker_alarm(res.data.body);
                  }
                }
              } else if (newInfo.action === "clearAlarm") {
                console.log(
                  "清除报警了-=-search_model=-=-=-",
                  this.search_model
                );
                if (this.search_model) {
                  if (newInfo.deviceId == this.search_model.deviceId) {
                    this.search_model.status = res.data.body.status;
                    this.search_marker_alarm(res.data.body);
                  }
                }
                var count = this.alarm_list.length;
                this.alarm_list.forEach((_item, _index) => {
                  if (_item.deviceId == newInfo.deviceId) {
                    this.alarm_list.splice(_index, 1);
                  }
                });
                if (count == this.alarm_list.length) {
                  this.alarmlist_in_select.forEach((_item, _index) => {
                    if (_item.deviceId == newInfo.deviceId) {
                      this.alarmlist_in_select.splice(_index, 1);
                    }
                  });
                }
                if (this.alarm_list.length === 0) {
                  window.baojingmp3_gaode.pause();
                  clearInterval(this.clearMesInterval);
                }
              }
            }
          });
      }
    },
    detailsclose() {
      this.dialogFormVisible = false;
    },
    diag_mapstyle_close() {
      this.dialogMapStyleVisible = false;
      var zoom = this.amap_map.getZoom(); //获取当前地图级别
      var center = this.amap_map.getCenter(); //获取当前地图中心位置
      console.log("当前中心点-=--=-=-center", [center.lng, center.lat]);
      console.log("当前视距离-=--=-=-", zoom);
    },
    //页面自适应
    onWindowResize() {
      let pageHeight = document.documentElement.clientHeight; //页面总高度
      if (
        document.querySelectorAll(".amap_box") &&
        document.querySelectorAll(".amap_box")[0]
      ) {
        document.querySelectorAll(".amap_box")[0].style.height =
          pageHeight - 65 + "px"; //在这里可以根据你的边距做调整
      }
    },
    initBasemap() {
      for (var item in this.map_config) {
        this.mapData[item] = this.map_config[item];
      }
      console.log('mapdata数据',this.mapData)
      this.new_Geography_Map(this.mapData.cityname);
    },
    initCreateMap() {
      var vue = this;
      this.cluster = null;
      var map_config_value = {
        mapzhuti: "amap://styles/b1220e2e801fbd718425afa88df21dbb",
        delivery: false,
        type: ["bg", "road", "building", "point"],
        mapType: "normal"
      };
      var maptypedata = localStorage.getStore("map_data_Config");
      for (var item in maptypedata) {
        map_config_value[item] = maptypedata[item].value;
      }
      this.amap_map = new AMap.Map(this.$refs.amapBox, {
        mask: this.masklist,
        mapStyle: map_config_value.mapzhuti,
        center: this.mapData.lnglat.length==0?[103.122082, 35.719192]:this.mapData.lnglat,
        viewMode: map_config_value.delivery ? "3D" : null,
        pitch: 40,
        zoom: this.mapData.zoome,
        features: map_config_value.type,
        layers:
          map_config_value.mapType == "administration"
            ? [chinapp.GetdisCountry()]
            : map_config_value.mapType == "satellite"
            ? [
                new AMap.TileLayer.RoadNet({
                  //rejectMapMask:true
                }),
                new AMap.TileLayer.Satellite()
              ]
            : null
      });
      if (
        map_config_value.mapType == "administration" &&
        map_config_value.type.includes("point")
      ) {
        this.amap_map.on("complete", function() {
          var layer = new AMap.LabelsLayer({
            zIndex: 10,
            // 开启标注避让，默认为开启，v1.4.15 新增属性
            collision: false,
            // 开启标注淡入动画，默认为开启，v1.4.15 新增属性
            animation: true
          });
          for (var i = 0; i < LabelsData.length; i++) {
            var labelsMarker = new AMap.LabelMarker(LabelsData[i]);
            layer.add(labelsMarker);
          }
          vue.amap_map.add(layer);
        });
      }
      if (
        !map_config_value.type.includes("road") &&
        map_config_value.mapType == "satellite"
      ) {
        var satellite = new AMap.TileLayer.Satellite({
          map: this.amap_map,
          zIndex: 12,
          opacity: 0.8
        });

        var roadNetLayer = new AMap.TileLayer.RoadNet({
          map: this.amap_map,
          zIndex: 0,
          opacity: 0.8
        });
      }

      this.page_init();
    },
    new_Geography_Map(name) {
      var opts = {
        subdistrict: 0,
        extensions: "all",
        level: "city"
      };
      //暂时取消掉地图模型数据缓存
      // var result = localStorage.getStore("mapbounds")[name];
      // if (result) {
      //   var bounds = this.pakounzip(result);
      //   for (var i = 0; i < bounds.length; i += 1) {
      //     this.masklist.push([bounds[i]]);
      //   }
      //   this.mapData.bounds = bounds;
      //   this.initCreateMap();
      // } else {
        var district = new AMap.DistrictSearch(opts);
        let vue = this;
        district.search(name, function(status, result) {
          var bounds = result.districtList[0].boundaries;
          var mask = [];
          for (var i = 0; i < bounds.length; i += 1) {
            mask.push([bounds[i]]);
          }
          // var loca_bounds ={
          //   name:vue.pakozip(bounds)
          // } 
          // localStorage.setStore("mapbounds", loca_bounds);
          vue.mapData.bounds = bounds;
          vue.masklist = mask;
          vue.initCreateMap();
        });
      // }
    },
    pakozip(data) {
      if (!data) return data;
      // 判断数据是否需要转为JSON
      const dataJson =
        typeof data !== "string" && typeof data !== "number"
          ? JSON.stringify(data)
          : data;
      // 使用Base64.encode处理字符编码，兼容中文
      const str = Base64.encode(dataJson);
      let binaryString = pako.gzip(str);
      let arr = Array.from(binaryString);
      let s = "";
      arr.forEach((item, index) => {
        s += String.fromCharCode(item);
      });
      return btoa(s);
    },
    pakounzip(b64Data) {
      let strData = atob(b64Data);
      let charData = strData.split("").map(function(x) {
        return x.charCodeAt(0);
      });
      let binData = new Uint8Array(charData);
      let data = pako.ungzip(binData);

      // ↓切片处理数据，防止内存溢出报错↓
      let str = "";
      const chunk = 8 * 1024;
      let i;
      for (i = 0; i < data.length / chunk; i++) {
        str += String.fromCharCode.apply(
          null,
          data.slice(i * chunk, (i + 1) * chunk)
        );
      }
      str += String.fromCharCode.apply(null, data.slice(i * chunk));
      // ↑切片处理数据，防止内存溢出报错↑

      const unzipStr = Base64.decode(str);
      let result = "";

      // 对象或数组进行JSON转换
      try {
        result = JSON.parse(unzipStr);
      } catch (error) {
        if (/Unexpected token o in JSON at position 0/.test(error)) {
          // 如果没有转换成功，代表值为基本数据，直接赋值
          result = unzipStr;
        }
      }
      return result;
    },
    //头部点击查看场站信息
    returnHome() {
        console.log('点击返回')
      this.amap_map.clearMap();
      this.page_init();
    },
    changePartMarker(type) {
      this.amap_map.clearMap();
      this.page_init(type);
    },
    noticeRefresh() {
      this.amap_map.clearMap();
      this.page_init();
    },
    getStyle(context) {
      var clusterData = context.clusterData; // 聚合中包含数据
      var index = context.index; // 聚合的条件
      var count = context.count; // 聚合中点的总数
      var marker = context.marker; // 聚合绘制点 Marker 对象
      var color = [
        "8, 60, 156",
        "0, 110, 255",
        "0, 183, 255",
        "78,200,211",
        "78,200,211"
      ];
      var indexs = ["province", "city", "area", "town"];
      var i = indexs.indexOf(index["mainKey"]);
      var text = clusterData[0][index["mainKey"]];
      console.log("-=--=-indexs-=--", i);
      var size = Math.round(
        30 + Math.pow(count / this.messmark.length, 1 / 5) * 70
      );
      var size = Math.round(
        30 + Math.pow(count / this.messmark.length, 1 / 5) * 70
      );
      var size = 83;
      if (i <= 3) {
        count = clusterData[0].count[index["mainKey"]] + "台";
        var extra = '<span class="showCount">' + count + "</span>";
        text = '<span class="showName">' + text + "</span>";
        text += extra;
      } else {
        size = 12 * text.length + 20;
      }
      var style = {
        bgColor: "rgba(" + color[i] + ",.8)",
        borderColor: "rgba(" + color[i] + ",1)",
        text: text,
        size: size,
        index: i,
        color: "#ffffff",
        textAlign: "center",
        boxShadow: "0px 0px 5px rgba(0,0,0,0.8)"
      };
      return style;
    },
    getPosition(context) {
      var key = context.index.mainKey;
      var dataItem = context.clusterData && context.clusterData[0];
      var districtName = dataItem[key];
      if (!this.district[districtName]) {
        return null;
      }
      var center = this.district[districtName].split(",");
      var centerLnglat = new AMap.LngLat(center[0], center[1]);
      return centerLnglat;
    },
    _customRender(data) {
      const keys = Object.keys(data.clusterData);
      let markers = [];
      var icon = {
        // 图标类型，现阶段只支持 image 类型
        type: "image",
        // 图片 url
        image: require("../../../../../static/img/tybox_gre.png"),
        // 图片尺寸
        size: [28, 28],
        // 图片相对 position 的锚点，默认为 bottom-center
        anchor: "center"
      };
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var cluster = data.clusterData[key];
        var position = cluster.data[0].lnglat;
        var marker = new AMap.LabelMarker({
          position: position,
          text: {
            content: cluster.data.length.toString(),
            style: {
              fillColor: "#ffffff"
            }
          }
        });
        markers.push(marker);
      }
      return {
        type: "type",
        layer: null,
        markers: markers
      };
    },
    getdevAllrequest(item) {
      if (!this.add_marker_stus.includes(item.areaId)) {
        this.add_marker_stus.push(item.areaId);
        this.$http
          .get(dataUrl.interfaceAddress.devAllUrl, {
            params: { townId: item.areaId }
          })
          .then(res => {
            if (res.data.code === 0) {
              this.map_data = res.data.body;
              // //高德地图打点
              this.creatMark(this.map_data);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //弹出二级页面dialog
    marker_info_dialogpush(item) {
      if (this.dialogFormVisible) {
        this.detailsclose();
      }
      this.infodata.deviceId = item.deviceId;
      // this.dialogFormVisible = true;
      console.log('设备台账item',item)
      this.$bus.$emit("push_device_tabs",item)
    },
    page_init(scencId) {
      window.baojingmp3_gaode = document.getElementById("gaode_audiol");
      if (this.mapData.Grade == 2) {
        this.mapdata_million(scencId)
      } else {
        this.mapdata_hundred(scencId)
      }
    },
    // 百万级设备展示
    mapdata_million(scencId) {
      var vue = this;
      this.$http
        .get(dataUrl.interfaceAddress.townPoint, {
          params: { scencId: scencId }
        })
        .then(res => {
          if (res.data.code === 0) {
            var postions = res.data.body.town;
            var filterData = res.data.body.coordinate;
            this.messmark = [];
            this.markers = [];
            this.alarmlist_in_select = [];
            if (postions) {
              for (var i in postions) {
                var item = postions[i];
                var mark = {
                  lnglat: item.center.split(","),
                  area: item.areaName,
                  town: item.townName,
                  province: item.provinceName,
                  city: item.cityName,
                  areaId: item.townId,
                  count: item.count
                };
                this.messmark.push(mark);
                var key = item.townName;
                if (!filterData[key]) {
                  filterData[key] = item.center;
                }
              }
              this.amap_map.on("zoomend", function() {
                var zoom = vue.amap_map.getZoom(); //获取当前地图级别
                console.log("缩放等级-=-=-=-=-", zoom);
                if (zoom >= 16) {
                  if (vue.cluster1 == null && vue.serach_marker == null) {
                    vue.cluster1 = new AMap.MarkerCluster(
                      vue.amap_map,
                      vue.markers,
                      {
                        styles: vue.markstyle,
                        gridSize: 400, // 设置网格像素大小
                        maxZoom: 20,
                        renderMarker: vue._renderMarker1, // 自定义非聚合点样式
                        renderClusterMarker: this._renderClusterMarker1
                      }
                    );

                    vue.cluster1.on("click", item => {
                      item.clusterData.length > 1
                        ? vue.$bus.$emit(
                            "marker_cluster_click",
                            item.clusterData
                          )
                        : null;
                    });
                  }
                } else {
                  vue.setSrarchMarker_Cluster1_Null();
                }
              });
              this.district = filterData;
              if (!this.cluster) {
                console.log(this.messmark)
                this.cluster = new AMap.IndexCluster(
                  this.amap_map,
                  this.messmark,
                  {
                    renderClusterMarker: this._renderClusterMarker,
                    clusterIndexSet: this.clusterIndexSet
                  }
                );
                this.map_setBgColor();
              } else {
                this.cluster.setData([]);
                this.cluster.setData(this.messmark);
                this.setSrarchMarker_Cluster1_Null();
                this.setMapCenterSize();
              }
              
              res.data.body.alarmList.length > 0?this.deviceAllAlarmList(res.data.body.alarmList):null
            } else {
              throw new Error("The interface return format is incorrect");
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 百量级设备展示
    mapdata_hundred(scencId) {
        let vue = this;
      this.$http
        .get(dataUrl.interfaceAddress.devAllUrl, {
            params: { scencId: scencId }
        })
        .then(res => {
          if (res.data.code === 0) {
            this.map_data = res.data.body;
            this.setSrarchMarker_Cluster1_Null();
            // //高德地图打点
            this.markers = []
            this.creatMark(this.map_data);
            this.map_setBgColor();

            this.cluster1 = new AMap.MarkerCluster(
              this.amap_map,
              this.markers,
              {
                gridSize: 40,
                renderMarker: vue._renderMarker1 // 自定义非聚合点样式
              }
            );
            console.log('中心点',this.mapData.lnglat)

            this.cluster1.on("click", item => {
              item.clusterData.length > 1
                ? vue.$bus.$emit("marker_cluster_click", item.clusterData)
                : null;
            });
            var markers_ = [];
            for (let item in this.map_data) {
              if (
                this.map_data[item] instanceof Array &&
                this.map_data[item].length &&
                !isNaN(Number(item))
              ) {
                var itemarray = [];
                this.map_data[item].forEach((i, n) => {
                  if (i.position[0] === "" || i.position[1] === "") {
                    return;
                  }
                  var marker = new AMap.Marker({
                    position: i.position.split(",")
                  });

                  markers_.push(marker);
                });
              }
            }
            scencId!=null || this.mapData.lnglat.length==0 ? this.amap_map.setFitView(markers_, false, [60, 60, 60, 60]):this.amap_map.setZoomAndCenter(this.mapData.zoome, this.mapData.lnglat)
            res.data.body.alarmList.length > 0?this.deviceAllAlarmList(res.data.body.alarmList):null
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    deviceAllAlarmList(alarmList){
        window.baojingmp3_gaode.pause();
        clearInterval(this.clearMesInterval);
        window.baojingmp3_gaode.play();
        this.clearMesInterval = setInterval(() => {
            window.baojingmp3_gaode.play();
        }, 1000);
        this.alarm_list = alarmList;
    },
    map_setBgColor() {
      setTimeout(() => {
        var height = document.querySelectorAll(".amap_box")[0].style.height;
        var width = document.querySelectorAll(".amap_box")[0].style.width;
        var box = document.getElementsByClassName("amap-container")[0];
        box.style.cssText =
          "width:" +
          width +
          ";" +
          "height:" +
          height +
          ";" +
          "background: rgba(211, 211, 106, 0)";

        if (this.mapData.cityname !== "中国") {
          //添加描边
          for (var i = 0; i < this.mapData.bounds.length; i += 1) {
            new AMap.Polyline({
              path: this.mapData.bounds[i],
              strokeColor: "#99ffff",
              strokeWeight: 2,
              map: this.amap_map
            });
          }
        }
      }, 2000);
    },
    //是否接警
    is_receive(item, index) {
      console.log("接受当前预警信息", item, index);
      // 请求接口 成功后 重新获取新数据
      this.getIsReceiveFunc(item);
    },
    //接警处理
    getIsReceiveFunc(item) {
      this.$http
        .put(dataUrl.interfaceAddress.answerAlarmUrl, {
          id: item.id,
          remark: "大屏接警"
        })
        .then(res => {
          // code=1时弹框小时，code=2时弹框继续显示，description 为提示语
          if (res.data.code === 0) {
            this.alarm_list.forEach((_item, _index) => {
              if (_item.id == item.id) {
                this.alarm_list.splice(_index, 1);
              }
            });
            let message = res.data.info;
            this.$message({
              message: message,
              type: "success"
            });
            if (this.alarm_list.length === 0) {
              window.baojingmp3_gaode.pause();
              clearInterval(this.clearMesInterval);
            }
            this.$bus.$emit("get-alarmList-bus");
          } else {
            let message = res.data.info;
            this.$message.error(message);
            this.$bus.$emit("get-alarmList-bus");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //获取详情
    alarmDetail(item, index, exeindex) {
      if (exeindex == 0) {
        console.log("隐藏报警提示框");
        window.baojingmp3_gaode.pause();
        clearInterval(this.clearMesInterval);
        this.alarm_list = this.alarm_list.filter(function(itemes) {
          if (itemes.deviceName !== item.deviceName) {
            return itemes;
          }
        });
        this.alarmlist_in_select.push(item);
        return;
      } else if (exeindex == 1) {
        this.$bus.$emit("alarm-box-detail", item);
      } else if (exeindex == 2) {
        console.log("解除报警操作-=-=-=-", item);
        this.$msgbox({
          title: "报警解除提示",
          message: "确认后将解除本次报警",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "执行中...";
              let params = {
                deviceId: item.deviceId || "",
                alarmTypeId: item.alarmTypeId || ""
              };

              this.params = params;
              this.$http
                .put(dataUrl.interfaceAddress.clearAlarmTask, {
                  id: item.id,
                  remark: "报警弹框解除报警"
                })
                .then(res => {
                  if (res.data && res.data.code == 0) {
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = "确认";
                    done();
                    let message = res.data.info;
                    this.$message({
                      message: message,
                      type: "success"
                    });
                    this.alarm_list.forEach((_item, _index) => {
                      if (
                        _item.deviceId == this.params.deviceId &&
                        _item.alarmTypeId == this.params.alarmTypeId
                      ) {
                        this.alarm_list.splice(_index, 1);
                      }
                    });
                    if (this.alarm_list.length == 0) {
                      window.baojingmp3_gaode.pause();
                      clearInterval(this.clearMesInterval);
                    }
                    this.$bus.$emit("get-alarmList-bus");
                  } else {
                    let message = res.data.description;
                    this.$message.error(message);
                  }
                })
                .catch(err => {
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "确认";
                  done();
                  this.$message({
                    message: "执行失败，请重试",
                    type: "warning"
                  });
                });
            } else {
              done();
            }
          }
        });
      }else{
        console.log('设备位置',item)
       
        this.handleSearch([item.deviceId])
      }
    },
    //详情中手动解除报警
    clear_alarm() {
      this.showDialog = false;
      this.$http
        .post(dataUrl.interfaceAddress.clearAlarmTask, this.params)
        .then(res => {
          if (res.data && res.data.code == 1) {
            let message = res.data.description;
            this.$message({
              message: message,
              type: "success"
            });
            this.alarm_list.forEach((_item, _index) => {
              if (
                _item.deviceId == this.params.deviceId &&
                _item.alarmTypeId == this.params.alarmTypeId
              ) {
                this.alarm_list.splice(_index, 1);
              }
            });
            if (this.alarm_list.length == 0) {
              window.baojingmp3_gaode.pause();
              clearInterval(this.clearMesInterval);
            }
            this.$bus.$emit("get-alarmList-bus");
          } else {
            let message = res.data.description;
            this.$message.error(message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    devStatusChange(data, deviceId) {
      //--条件都不成立会进这里面--//
      var vue = this;
      let string = "";
      data.alarm.value.map(item => {
        string += item + " ";
      });
      var newinfo = {
        levelName: string,
        deviceName: data.deviceName,
        devicePosition: data.address,
        time: data.alarm.time,
        id: data.alarm.alarmId,
        deviceId: deviceId,
        alarmTypeId: data.alarm.alarmFieldId
      };
      window.baojingmp3_gaode.pause();
      clearInterval(this.clearMesInterval);
      window.baojingmp3_gaode.play();
      this.clearMesInterval = setInterval(() => {
        window.baojingmp3_gaode.play();
      }, 1000);
      var arrays = vue.alarm_list.concat(vue.alarmlist_in_select);
      let newValInfo = arrays.filter(_item => {
        if (
          _item.alarmTypeId == newinfo.alarmTypeId &&
          _item.deviceId == newinfo.deviceId
        ) {
          return _item;
        }
      });

      if (newValInfo.length === 0) {
        vue.alarm_list.push(newinfo);
      }
    },
    mapinfowindows_open(body, item) {
      var title = body.deviceName,
        content = [];
      content.push(
        "<div class='marker-group'><div class='item-img'><img style='width:100px;height:80px' src='" +
          body.picture +
          "'></div><div class='item-span'>"
      );
      body.showData.forEach((i, n) => {
        content.push("<span>" + i.key + ":" + i.val);
      });
      content.push("</div></div>");
      this.infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: this.createInfoWindow(
          title,
          content.join("</span>"),
          item.status
        ),
        offset: new AMap.Pixel(16, -45)
      });
      this.infoWindow.open(this.amap_map, item.lnglat);
    },
    mapCartographicClick() {
      var zoom = this.amap_map.getZoom(); //获取当前地图级别
      var center = this.amap_map.getCenter(); //获取当前地图中心位置
      this.amap_map.setCenter(center); //设置地图中心点
      this.amap_map.setZoom(zoom); //设置地图层级
    },
    creatMark(info) {
      let arr = [];
      // this.markers = [];
      //   this.messmark = this.messmark.filter(function(item) {
      //     if (item.community !== itemes.community) {
      //       return item;
      //     }
      //   });
      for (let item in info) {
        if (
          info[item] instanceof Array &&
          info[item].length &&
          !isNaN(Number(item))
        ) {
          let vue = this;
          var itemarray = [];
          info[item].forEach((i, n) => {
            if (i.position[0] === "" || i.position[1] === "") {
              return;
            }
            this.markers.push({
              lnglat: i.position.split(","),
              sceneId: item,
              status: i.status,
              deviceId: i.deviceId
            });
          });
        }
      }
      console.log("网络请求后markers数据", this.markers);
    },
    _renderClusterMarker1(context) {
      var clusterData = context.clusterData; // 聚合中包含数据
    },
    _renderMarker1(context) {
      let vue = this;
      var clusterData = context.data; // 聚合中包含数据
      var offset = new AMap.Pixel(-9, -9);
      const qiyeHtml = `<img style='width: 20px; height: 20px;' src='${this.getImger(
        clusterData[0]
      )}'/>`;

      context.marker.setContent(qiyeHtml);
      context.marker.setOffset(offset);
      context.marker.setTop(top);
      context.marker.setExtData({
        item: clusterData[0]
      });
      //此处为添加单个标记点击事件
      context.marker.on("click", ev => {
        // var curZoom = this.amap_map.getZoom();
        //当前标记居中
        // this.amap_map.setZoomAndCenter(curZoom, ev.target.getPosition());
        //获取标记携带的数据
        const extData = ev.target.getExtData();
        this.marker_info_dialogpush(extData.item);
      });
      //此处为添加单个标记点击事件
      context.marker.on("mouseout", ev => {
        this.closeInfoWindow();
      });
      //此处为添加单个标记点击事件
      context.marker.on("mouseover", ev => {
        // <span style="font-size:11px;color:#F00;">浓度:300LEL%</span>
        const extData = ev.target.getExtData();
        this.$http
          .get(dataUrl.interfaceAddress.getDevbounced, {
            params: { deviceId: extData.item.deviceId }
          })
          .then(res => {
            var body = res.data.body;
            var newitem = {
              status: body.status,
              lnglat: [ev.lnglat.lng, ev.lnglat.lat]
            };
            vue.mapinfowindows_open(body, newitem);
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    createInfoWindow(title, content, status) {
      var info = document.createElement("div");
      var class1 = "custom-info-gre";
      var class2 = "info-top-gre";
      var textcolor = "#24e9e9";
      var imgsrc = "../../../../../static/img/sharp.png";
      var imgsrc1 = "../../../../../static/img/close2=.png";
      status == 1
        ? ((class1 = "custom-info-gry"),
          (class2 = "info-top-gry"),
          (textcolor = "#ffffff"),
          (imgsrc = "../../../../../static/img/sharp_bai.png"),
          (imgsrc1 = "../../../../../static/img/close2=bai.png"))
        : status == 2
        ? ((class1 = "custom-info-red"),
          (class2 = "info-top-red"),
          (textcolor = "#ee3608"),
          (imgsrc = "../../../../../static/img/sharp_red.png"),
          (imgsrc1 = "../../../../../static/img/close2=red.png"))
        : null;
      info.className = class1 + " input-card content-window-card";
      //可以通过下面的方式修改自定义窗体的宽高
      info.style.width = "400px";
      // 定义顶部标题
      var top = document.createElement("div");
      var titleD = document.createElement("div");
      var closeX = document.createElement("img");
      top.className = "info-top " + class2;
      titleD.innerHTML = title;
      closeX.src = imgsrc1;
      closeX.onclick = this.closeInfoWindow;

      top.appendChild(titleD);
      top.appendChild(closeX);
      info.appendChild(top);

      // 定义中部内容
      var middle = document.createElement("div");
      middle.className = "info-middle";
      middle.style.color = textcolor;
      middle.innerHTML = content;
      info.appendChild(middle);

      // 定义底部内容
      var bottom = document.createElement("div");
      bottom.className = "info-bottom";
      bottom.style.position = "relative";
      bottom.style.top = "0px";
      bottom.style.margin = "0 auto";
      var sharp = document.createElement("img");
      sharp.src = imgsrc;

      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },

    // 自定义聚合点样式
    _renderClusterMarker(context) {
      var vue = this;
      var clusterData = context.clusterData; // 聚合中包含数据
      var index = context.index; // 聚合的条件
      var count = context.count; // 聚合中点的总数
      var marker = context.marker; // 聚合点标记对象
      var styleObj = this.getStyle(context);

      if (styleObj.index <= 3) {
        var div = document.createElement("div");
        div.className = "amap-cluster";
        div.style.backgroundColor = styleObj.bgColor;
        div.style.width = styleObj.size + "px";
        div.style.border = "solid 1px " + styleObj.borderColor;
        div.style.borderRadius = styleObj.size + "px";
        div.innerHTML = styleObj.text;
        div.style.color = styleObj.color;
        div.style.textAlign = styleObj.textAlign;
        div.style.boxShadow = styleObj.boxShadow;
        if (styleObj.index == 3) {
          this.getdevAllrequest(clusterData[0]);
        }
        div.style.height = styleObj.size + "px";
        // 自定义点击事件
        context.marker.on("click", function(e) {
          var curZoom = vue.amap_map.getZoom();
          if (curZoom >= 14) {
            curZoom += 1;
          }
          vue.amap_map.setZoomAndCenter(curZoom, e.lnglat);
        });
        // 自定义点标记样式

        context.marker.setContent(div);
      }

      var position = this.getPosition(context);

      if (position) {
        context.marker.setPosition(position);
      }
      context.marker.setAnchor("center");
    },
    getImger(item) {
      var sceneId = item.sceneId;
      var status = item.status;
      var img;
      if (sceneId == 5) {
        //场站，储配站
        img =
          status == 0
            ? require("../../../../../static/img/station_gre.png")
            : status == 2
            ? require("../../../../../static/img/station_red.png")
            : require("../../../../../static/img/station_gry.png");
      }
      if (sceneId == 6) {
        //阀门井
        img =
          status == 0
            ? require("../../../../../static/img/valve_gre.png")
            : status == 2
            ? require("../../../../../static/img/valve_red.png")
            : require("../../../../../static/img/valve_gry.png");
      }
      if (sceneId == 7) {
        //阴极桩
        img =
          status == 0
            ? require("../../../../../static/img/cathode_gre.png")
            : status == 2
            ? require("../../../../../static/img/cathode_red.png")
            : require("../../../../../static/img/cathode_gry.png");
      }
      if (sceneId == 3) {
        //调压箱
        img =
          status == 0
            ? require("../../../../../static/img/tybox_gre.png")
            : status == 2
            ? require("../../../../../static/img/tybox_red.png")
            : require("../../../../../static/img/tybox_gry.png");
      }
      if (sceneId == 4) {
        //调压站
        img =
          status == 0
            ? require("../../../../../static/img/tybox_gre.png")
            : status == 2
            ? require("../../../../../static/img/tybox_red.png")
            : require("../../../../../static/img/tybox_gry.png");
      }
      if (sceneId == 2) {
        //民品
        img =
          status == 0
            ? require("../../../../../static/img/civil_gre.png")
            : status == 2
            ? require("../../../../../static/img/civil_red.png")
            : require("../../../../../static/img/civil_gry.png");
      }
      if (sceneId == 1) {
        //商业主机
        img =
          status == 0
            ? require("../../../../../static/img/merchant_gre.png")
            : status == 2
            ? require("../../../../../static/img/merchant_red.png")
            : require("../../../../../static/img/merchant_gry.png");
      }
      if (sceneId == 8) {
        //泄漏监测仪
        img =
          status == 0
            ? require("../../../../../static/img/merchant_gre.png")
            : status == 2
            ? require("../../../../../static/img/merchant_red.png")
            : require("../../../../../static/img/merchant_gry.png");
      }
      if (sceneId == 9) {
        //消杀产品
        img =
          status == 0
            ? require("../../../../../static/img/Kill_gre.png")
            : status == 2
            ? require("../../../../../static/img/Kill_red.png")
            : require("../../../../../static/img/Kill_gry.png");
      }
      if (sceneId == 10) {
        //消杀产品
        img =
          status == 0
            ? require("../../../../../static/img/dlbjq_gre.png")
            : status == 2
            ? require("../../../../../static/img/dlbjq_red.png")
            : require("../../../../../static/img/dltt_gry.png");
      }
      return img;
    },
    //   var width = document.body.clientWidth / 4;
    //   var height = document.body.clientHeight / 4;
    //   this.getMarkerPoint(width,height,[621.5,0]);
    getMarkerPoint(width, height, [xpoint, ypoint]) {
      console.log("原始坐标点width", width);
      console.log("原始坐标点height", height);
      console.log("原始坐标点xpoint", xpoint);
      console.log("原始坐标点ypoint", ypoint);
      var path = [];
      for (var i = 0; i < 3; i++) {
        var y = height * i;
        for (var j = 0; j < 3; j++) {
          var x = width * j + xpoint;
          console.log("坐标系-=-=--", [x, y]);
          path.push(this.container2lnglat([x, y]));
        }
      }
      var path_indx = [
        [0, 1, 4, 3, 0],
        [1, 2, 5, 4, 1],
        [3, 4, 7, 6, 3],
        [4, 5, 8, 7, 4]
      ];
      for (var i = 0; i < path_indx.length; i++) {
        var marks = [];
        for (var j = 0; j < path_indx[i].length; j++) {
          var indx = path_indx[i][j];
          console.log("下标点", indx);
          marks.push(path[indx]);
          var polygon = new AMap.Polygon({
            map: this.amap_map,
            fillOpacity: 0.4,
            path: marks
          });
        }
      }
    },
    // 容器像素坐标转成经纬度坐标
    container2lnglat(pixel) {
      if (!pixel) return;
      var pixel = new AMap.Pixel(pixel[0], pixel[1]);
      var lnglat = this.amap_map.containerToLngLat(pixel);
      console.log("屏幕坐标转换后经纬度坐标-=-=-=-=--", [
        lnglat.lng,
        lnglat.lat
      ]);
      return [lnglat.lng, lnglat.lat];
    },
    setSrarchMarker_Cluster1_Null() {
      if (this.cluster1) {
        this.cluster1.setData([]);
        this.cluster1 = null;
      }
      if (this.serach_marker) {
        this.serach_marker.setMap(null);
        this.serach_marker = null;
        this.search_model = null;
        this.closeInfoWindow();
      }
    },
    setClusterMapSize() {
      this.amap_map.getCenter();
      this.amap_map.setFitView();
      if (this.mapType == "country") {
        this.amap_map.setZoom(this.mapSize);
      }
      this.amap_map.setZoomAndCenter(this.amap_map.getZoom() + 1, [lng, lat]);
    },
    setMapCenterSize() {
      this.amap_map.setFitView();
      this.amap_map.setCenter([103.122082, 35.719192]);
      this.amap_map.setZoom(4.8);
    },
    //关闭弹窗
    closeDialog() {
      this.showDialog = false;
    },
    //dialog_click关闭弹窗
    closeDialog_click_win() {
      this.showClickDialog = false;
    },
    //关闭信息窗体
    closeInfoWindow() {
      this.amap_map.clearInfoWindow();
    },
    /**
     * 关闭报警音乐
     *
     * */
    close_audio() {
      window.baojingmp3_gaode.pause();
      clearInterval(this.clearMesInterval);
    }
  },
  //** /获取弹框的详情 **//
  destory() {
    window.onresize = null;
    clearInterval(this.clearMesInterval); //清除音乐的定时器
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onWindowResize);
    this.$bus.$off("map_init_bus", this.page_init);
    this.$bus.$off("emitter-excu-sign-out-event", this.close_audio);
    this.$bus.$off("change-info-event", this.changeInfo);
  }
};
</script>
<style>
.amap-cluster {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
}
.showName {
  font-size: 14px;
}
.showCount,
.showName {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 80%;
}
</style>
<style lang="less" scoped>
.map_style {
  padding: 0px 0px 0px 0px;
  width: 100%;
  height: 100%;
  background: url("https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/bg-min.png")
    no-repeat;
  background-size: 100% 100%;
  position: relative;
  background-color: transparent;
  .zoomIcon {
    width: 20px;
    height: 20px;
    background: url(https://jcmq-1258325762.cos.ap-chengdu.myqcloud.com/monitor/static/img/shrink.png)
      no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 20px;
    left: 24%;
    z-index: 10;
    cursor: pointer;
  }

  .sync {
    width: 20px;
    height: 20px;
    background: url(../../../../../static/img/two.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 20px;
    left: 22%;
    z-index: 10;
    cursor: pointer;
  }
  .hid-alarm-box {
    // background: url(../../../../../static/img/icon/4.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: 15px;
    left: 26%;
    z-index: 10;
    cursor: pointer;
  }

  .xunjian {
    width: 20px;
    height: 20px;
    /*background: url(../../../../../static/img/Inspectors.png) no-repeat;*/
    background-size: 100% 100%;
    position: absolute;
    top: 10px;
    right: 80px;
    z-index: 10;
    cursor: pointer;
  }

  .alarm_box {
    width: 614px;
    height: 314px;
    // opacity: 0.5;
    position: fixed;
    top: 50%;
    left: 50%;
    margin: -157px 0 0 -307px;
  }
  & /deep/ .amap-container {
    touch-action: none;
    position: relative;
    overflow: hidden;
    -ms-touch-action: none;
    // background: rgba(211, 211, 106, 0);
  }
  & /deep/ .el-button--success {
    color: #92e2f0;
    background-color: transparent;
    border-color: #409eff;
  }
  & /deep/ .el-button--primary {
    color: #92e2f0;
    background-color: rgba(15, 182, 211, 0.5);
    border-color: #409eff;
  }
  &
    /deep/
    .el-button-group
    .el-button--primary:not(:first-child):not(:last-child) {
    border-left-color: #409eff;
    border-right-color: #409eff;
  }
  & /deep/ .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100px;
    color: #92e2f0;
    // top: 1px;
  }
  & /deep/ .el-input__inner {
    height: 29px;
    background: transparent;
    border-color: #409eff;
    outline: none;
    font-size: 13px;
    color: #92e2f0;
  }
  & /deep/ .el-input__icon {
    line-height: 29px;
  }
  & /deep/ .el-icon-message-solid:before {
    color: red;
  }
}
</style>

<style>
.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  width: auto;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

.custom-info-gre {
  border-top: 1px solid #24e9e9;
  border-right: 1px solid #24e9e9;
  border-left: 1px solid #24e9e9;
}
.custom-info-red {
  border-top: 1px solid #ee3608;
  border-right: 1px solid #ee3608;
  border-left: 1px solid #ee3608;
}
.custom-info-gry {
  border-top: 1px solid #ffffff;
  border-right: 1px solid #ffffff;
  border-left: 1px solid #ffffff;
}

div.info-top {
  position: relative;
  background-color: none repeat scroll #24e9e9;
  border-radius: 10px 15px 0 0;
  backdrop-filter: blur(30px);
}
div.info-top-gre {
  border-bottom: 1px solid #24e9e9;
  color: #24e9e9;
}
div.info-top-red {
  border-bottom: 1px solid #ee3608;
  color: #ee3608;
}
div.info-top-gry {
  border-bottom: 1px solid #ffffff;
  color: #ffffff;
}

div.info-top div {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

div.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

div.info-middle {
  font-size: 12px;
  padding: 10px 6px;
  line-height: 20px;
  background-color: none repeat scroll #24e9e9;
  backdrop-filter: blur(30px);
}
div.marker-group {
  right: 0px;
  /* height: 120px; */
  /* margin: 10px; */
  width: 100%;
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: row;
}
.item-img {
  margin: auto;
  margin-left: 5px;
  margin-right: 0px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.item-span {
  margin: auto;
  display: flex;
  margin-left: 0px;
  flex-direction: column;
  position: relative;
}
div.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

div.info-bottom img {
  position: relative;
  z-index: 104;
}

span {
  margin-left: 5px;
  font-size: 11px;
}

.info-middle img {
  float: left;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/baseMap/base_map.vue